// extracted by mini-css-extract-plugin
export default {"container":"Zq-z","brandName":"_q-z","productName":"ar-z","productNamePdpEnhancements":"br-z","breakLongProductName":"cr-z"};